const modalButtons = document.querySelectorAll('.modal-open-button');
const modals = document.querySelectorAll('.full-page-modal');
const body = document.querySelector('body');
const sukiMobilMenu = document.querySelector('#mobile-vertical-header');

if(modalButtons.length > 0 && modals.length > 0) {

	hideAll();

	modalButtons.forEach((button) => {
		button.addEventListener('click', (event) => {
			showButtons(event.target.dataset.modalButtonId);
		});
	});

	document.addEventListener('keyup', function() {
		hideAll();
	});

	modals.forEach((modal) => {
		modal.addEventListener('click', function(event) {
			if (event.target.matches('button') || event.target.matches('a') ){
				return;
			} else {
				hideAll();
			}
		});
	});

}

function hideAll() {
	body.classList.remove('no-scroll');
	modals.forEach((modal) => {
		modal.classList.remove('modal-visible');
	});
}

function showButtons(modalId) {
	hideAll();
	hideSukiMobileMenu();

	modals.forEach((modal) => {
		if(modal.dataset.modal === modalId) {
			modal.classList.add('modal-visible');
			body.classList.add('no-scroll');
		}
	});
}

function hideSukiMobileMenu() {
	sukiMobilMenu.classList.remove('suki-popup-active');
}
